import { render } from "./ListaFilmes.vue?vue&type=template&id=50c450a0&scoped=true"
import script from "./ListaFilmes.vue?vue&type=script&lang=js"
export * from "./ListaFilmes.vue?vue&type=script&lang=js"

import "./ListaFilmes.vue?vue&type=style&index=0&id=50c450a0&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c450a0"]])

export default __exports__